import React, { Component } from "react";
import Input from '../components/common/Input';
import './style.scss';

export default class InputField extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { label, name, value, errors, onChange, placeholder, disabled, type, id } = this.props;
        return (
            <>
                <div className="m-t-10" id={id}>
                    <label htmlFor="title" className="form-labels">
                        {label}
                    </label>
                    <Input
                        name={name}
                        type={type}
                        value={value}
                        placeholder={placeholder}
                        disabled={disabled}
                        onChange={onChange}
                    />
                </div>
                {errors && <div className="field-error">{errors}</div>}
            </>
        )
    }
}

